<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick" style="margin-left: 8px;">
      <el-tab-pane label="中物系" name="zhongwu"> </el-tab-pane>
      <el-tab-pane label="兴瀚系" name="xinghan"> </el-tab-pane>
    </el-tabs>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
          <el-form-item label="日期:" class="item2">
            <el-date-picker
              v-model="searchFrom.dateRange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="现金流量项目:" >
            <el-select v-model="searchFrom.flowItemName" placeholder="请选择" size="mini">
              <el-option v-for="item in BMlist" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称:">
            <el-select  v-model="searchFrom.companyName" filterable placeholder="请选择" @change="fzgsChange">
              <el-option v-for="(item,index) in zigsList" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门名称:">
            <el-select v-model="searchFrom.department" filterable placeholder="请选择">
              <el-option v-for="(item,index) in FZbumenList" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式:">
            <el-select v-model="searchFrom.paymentMethod" filterable placeholder="请选择">
              <el-option v-for="(item,index) in paymentMethodArr" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入人:">
            <el-input v-model="searchFrom.createUser" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')" v-if="btnFlg[1]">重置</el-button>
            <el-button type="primary" size="mini" @click="addFn" v-if="btnFlg[5]">新增</el-button>
            <el-button type="primary" size="mini" @click="delFn" v-if="btnFlg[7]">删除</el-button>
            <el-button type="primary" size="mini" @click="importFn" v-if="btnFlg[2]">导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown" v-if="btnFlg[3]">模板下载</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu" v-if="btnFlg[4]">导出</el-button>
          </div>
          <el-form-item style="margin-left:8px">
            <span class="margin0" >
              收入合计:<span class="red">{{sum.totalIncome}}</span>元&nbsp;&nbsp;&nbsp;&nbsp;
              支出合计:<span class="red">{{sum.totalExpenditure}}</span>元
            </span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @row-click="handleRowClick"
        style="width: 100%" height="100%" center border :key="tableKey" class="tableComent" @selection-change='selectGoods'>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column width="70" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="btnFlg[6]">修改</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" align="center" :formatter="dateFormat" width="120"></el-table-column>
        <el-table-column prop="flowItemName" label="现金流量项目" align="center" width="210" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createSubcompanyName" label="公司名称" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDepartmentName" label="部门" align="center" width="150"></el-table-column>
        <el-table-column prop="income" label="收入(元)" align="center" ></el-table-column>
        <el-table-column prop="expenditure" label="支出(元)" align="center" ></el-table-column>
        <el-table-column prop="paymentMethod" label="付款方式" align="center" ></el-table-column>
        <el-table-column prop="supplierName" label="客户/供应商" align="center" width="150" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="remark" label="摘要" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="导入时间" :formatter="dateTimeFormat" width="180"></el-table-column>
        <el-table-column prop="createUser" label="导入人" align="center" width="120" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <!-- 新增/修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="close" center width="500px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="日期:" prop="date">
            <el-date-picker
              v-model="addForm.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              size="mini"
              style="width: 215px;"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="现金流量项目:" prop="flowItemName">
            <el-select v-model="addForm.flowItemName" placeholder="请选择" size="mini">
              <el-option v-for="item in BMlist" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称:">
            <!-- <el-select v-model="addForm.createSubcompanyName" filterable placeholder="请选择" size="mini">
              <el-option v-for="(item,index) in zigsList" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select> -->
            <el-autocomplete
              v-model="addForm.createSubcompanyName"
              :fetch-suggestions="queryCompanySearch"
              placeholder="请输入或选择公司名称"
              size="mini"
              style="width: 215px;"
              :trigger-on-focus="true"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="部门名称:">
            <!-- <el-select v-model="addForm.createDepartmentName" filterable placeholder="请选择" size="mini">
              <el-option v-for="(item,index) in FZbumenList" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select> -->
            <el-autocomplete
              v-model="addForm.createDepartmentName"
              :fetch-suggestions="queryDepartmentSearch"
              placeholder="请输入或选择部门名称"
              size="mini"
              style="width: 215px;"
              :trigger-on-focus="true"
              clearable
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="收入(元):" prop="income">
            <el-input v-model="addForm.income" v-number-input.float="2" maxlength="8" placeholder="请输入" size="mini" style="width: 215px;"></el-input>
          </el-form-item>
          <el-form-item label="支出(元):" prop="expenditure">
            <el-input v-model="addForm.expenditure" v-number-input.float="2" maxlength="8" placeholder="请输入" size="mini" style="width: 215px;"></el-input>
          </el-form-item>
          <el-form-item label="付款方式:" prop="paymentMethod">
            <el-autocomplete
              v-model="addForm.paymentMethod"
              :fetch-suggestions="queryPaymentMethodSearch"
              placeholder="请输入或选择付款方式"
              size="mini"
              style="width: 215px;"
              :trigger-on-focus="true"
              clearable
            ></el-autocomplete>
            <!-- <el-select v-model="addForm.paymentMethod" filterable placeholder="请选择" size="mini">
              <el-option v-for="(item,index) in paymentMethodArr" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="客户/供应商:">
            <el-input v-model="addForm.supplierName" placeholder="请输入" size="mini" style="width: 215px;"></el-input>
          </el-form-item>
          <el-form-item label="摘要:">
            <el-input type="textarea" v-model="addForm.remark" style="width:215px" rows="3"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn">保 存</el-button>
        <el-button @click="close" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findCashFlowItemLists, tFlowIncomeExpenditureDetailList, tFlowIncomeExpenditureDetailImport, tFlowIncomeExpenditureDetailOptions, tFlowIncomeExpenditureDetailAdd, tFlowIncomeExpenditureDetailUpdate, tFlowIncomeExpenditureDetailDelete } from '@/api/common-signature'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      emptyFn: emptyFn,
      activeName: 'zhongwu',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      BMlist: [],
      zigsList: [],
      FZbumenList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      isDaoChu: false,
      sum: {},
      importDialog: false,
      tableKey: 0,
      btnFlg: [],
      btnIdArr: ['00FM0X0100', '00FM0X0200', '00FM0X0300', '00FM0X0400', '00FM0X0500', '00FM0X0600', '00FM0X0700', '00FM0X0800'],
      paymentMethodArr: [],
      title: '新增',
      dialogVisible: false,
      addForm: {},
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        createSubcompanyName: [
          { required: true, message: '请选择公司名称', trigger: 'change' }
        ],
        createDepartmentName: [
          { required: true, message: '请选择部门名称', trigger: 'change' }
        ],
        flowItemName: [
          { required: true, message: '请选择项目名称', trigger: 'change' }
        ],
        income: [
          { required: true, message: '请输入收入', trigger: 'blur' }
        ],
        expenditure: [
          { required: true, message: '请输入支出', trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请选择付款方式', trigger: 'change' }
        ],
        supplierName: [
          { required: true, message: '请输入客户/供应商', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入摘要', trigger: 'blur' }
        ]
      },
      isAdd: false,
      selectionList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/transactionDetails')
    this.handleRouteParams()
    this.findCashFlowItemLists()
    this.getFKFS()
    this.getCompany()
    this.getBumen()
    // 然后获取列表数据
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    // 处理路由参数
    handleRouteParams () {
      const { department, cashflowItem, tenantFaction } = this.$route.query

      // 如果有部门参数
      if (department) {
        this.$set(this.searchFrom, 'department', department)
      }

      // 如果有现金流量项目参数
      if (cashflowItem) {
        this.$set(this.searchFrom, 'flowItemName', cashflowItem)
      }

      // 如果有租户标识参数，并设置对应的 tab
      if (tenantFaction !== undefined) {
        if (tenantFaction === 0 || tenantFaction === '0') {
          this.activeName = 'zhongwu'
        } else if (tenantFaction === 1 || tenantFaction === '1') {
          this.activeName = 'xinghan'
        }
      }

      // 如果有租户标识，重新获取对应租户的下拉选项
      if (tenantFaction !== undefined) {
        const flag = this.activeName === 'zhongwu' ? 0 : this.activeName === 'xinghan' ? 1 : ''
        this.getFKFS(flag)
        this.getCompany(flag)
        this.getBumen(flag)
      }
    },
    getFKFS (tenantFaction) {
      tFlowIncomeExpenditureDetailOptions({
        type: 'paymentMethod',
        tenantFaction: tenantFaction
      }).then(res => {
        this.paymentMethodArr = res.list
      })
    },
    getCompany (tenantFaction) {
      tFlowIncomeExpenditureDetailOptions({
        type: 'company',
        tenantFaction: tenantFaction
      }).then(res => {
        this.zigsList = res.list
      })
    },
    getBumen (tenantFaction) {
      tFlowIncomeExpenditureDetailOptions({
        type: 'department',
        tenantFaction: tenantFaction
      }).then(res => {
        this.FZbumenList = res.list
      })
    },
    findCashFlowItemLists () {
      findCashFlowItemLists().then((res) => {
        if (res.length > 0) {
          this.BMlist = res
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 选择分子公司
    fzgsChange (e) {
      // tFlowIncomeExpenditureDetailOptions({ type: 'department', company: e, tenantFaction: this.searchFrom.tenantFaction }).then(res => { this.FZbumenList = res.list })
      // this.$set(this.searchFrom, 'department', null)
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/现金流量项目收支明细导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      formData.append('importFaction', this.activeName === 'zhongwu' ? 0 : this.activeName === 'xinghan' ? 1 : '')
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      tFlowIncomeExpenditureDetailImport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        that.msg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        that.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else {
          this.$message({
            type: 'error',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    handleTabClick (e) {
      let flag = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      this.getFKFS(flag)
      this.getCompany(flag)
      this.getBumen(flag)
      this.tableKey += 1
      this.reinitializeTable()

      // 切换 tab 时，不清除路由参数，但可以更新 tenantFaction
      const routeTenantFaction = this.$route.query.tenantFaction
      if (routeTenantFaction === undefined) {
        // 如果没有路由参数，才使用 tab 的 tenantFaction
        this.searchFrom.tenantFaction = flag
      }

      this.searchFn()
    },
    // 重新初始化表格（核心方法）
    reinitializeTable () {
      // 1. 清空表格数据
      this.tableData = []

      // 2. 重置分页状态
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导出
    exportFn () {
      this.searchFrom.tenantFaction = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.smpName + '/tFlowIncomeExpenditureDetail/export',
        form,
        this.activeName == 'zhongwu' ? '中物系收支明细表' : this.activeName == 'xinghan' ? '兴瀚系收支明细表' : '汇总表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true

      // 优先使用路由参数中的 tenantFaction，如果没有则根据当前 tab 设置
      const routeTenantFaction = this.$route.query.tenantFaction
      if (routeTenantFaction !== undefined) {
        this.searchFrom.tenantFaction = routeTenantFaction
      } else {
        this.searchFrom.tenantFaction = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      }

      tFlowIncomeExpenditureDetailList(this.searchFrom).then(res => {
        this.tableList = res.pageInfo.list
        this.total = res.pageInfo.total
        this.sum = {
          totalExpenditure: res.totalExpenditure,
          totalIncome: res.totalIncome
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err.message)
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // 保存当前的路由参数
      const routeParams = {
        department: this.$route.query.department,
        cashflowItem: this.$route.query.cashflowItem,
        tenantFaction: this.$route.query.tenantFaction
      }

      // 重置搜索表单
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }

      // 如果有路由参数，重新设置
      if (routeParams.department) {
        this.$set(this.searchFrom, 'department', routeParams.department)
      }
      if (routeParams.cashflowItem) {
        this.$set(this.searchFrom, 'flowItemName', routeParams.cashflowItem)
      }
      if (routeParams.tenantFaction !== undefined) {
        this.$set(this.searchFrom, 'tenantFaction', routeParams.tenantFaction)
      }

      this.searchFn()
    },
    addFn () {
      this.dialogVisible = true
      this.isAdd = true
      this.$set(this.addForm, 'tenantFaction', this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : '')
    },
    initAddForm () {
      this.addForm = {}
      let flag = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      this.getFKFS(flag)
      this.getCompany(flag)
      this.getBumen(flag)
      this.searchFn()
    },
    close () {
      this.dialogVisible = false
      this.initAddForm()
    },
    editFn (row) {
      this.dialogVisible = true
      this.title = '修改'
      this.isAdd = false
      this.addForm = row
      this.$set(this.addForm, 'date', this.dateFormat1(row.date))
    },
    // 公司名称搜索建议
    queryCompanySearch (queryString, cb) {
      let results = []
      // 如果输入了内容，进行过滤
      if (queryString) {
        results = this.zigsList.filter(item =>
          item.name.toLowerCase().includes(queryString.toLowerCase())
        )
      } else {
        // 没有输入时显示所有选项
        results = this.zigsList
      }
      // 转换为 autocomplete 需要的格式
      results = results.map(item => ({ value: item.name }))
      cb(results)
    },
    // 部门名称搜索建议
    queryDepartmentSearch (queryString, cb) {
      let results = []
      // 如果输入了内容，进行过滤
      if (queryString) {
        results = this.FZbumenList.filter(item =>
          item.name.toLowerCase().includes(queryString.toLowerCase())
        )
      } else {
        // 没有输入时显示所有选项
        results = this.FZbumenList
      }
      // 转换为 autocomplete 需要的格式
      results = results.map(item => ({ value: item.name }))
      cb(results)
    },
    queryPaymentMethodSearch (queryString, cb) {
      let results = []
      // 如果输入了内容，进行过滤
      if (queryString) {
        results = this.paymentMethodArr.filter(item =>
          item.name.toLowerCase().includes(queryString.toLowerCase())
        )
      } else {
        // 没有输入时显示所有选项
        results = this.paymentMethodArr
      }
      // 转换为 autocomplete 需要的格式
      results = results.map(item => ({ value: item.name }))
      cb(results)
    },
    saveFn () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            tFlowIncomeExpenditureDetailAdd(this.addForm)
              .then(res => {
                console.log(res)
                loading.close()
                this.dialogVisible = false
                this.initAddForm()
                this.$message.success('添加成功')
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          } else {
            tFlowIncomeExpenditureDetailUpdate(this.addForm)
              .then(res => {
                console.log(res)
                loading.close()
                this.dialogVisible = false
                this.initAddForm()
                this.$message.success('添加成功')
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          }
        } else {
        }
      })
    },
    // 选择数据
    selectGoods (selection) {
      this.selectionList = this.$refs.table.selection
    },
    // 删除
    delFn () {
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择要操作的数据',
          type: 'error'
        })
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let ids = []
          this.selectionList.forEach(item => {
            ids.push(item.id)
          })
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tFlowIncomeExpenditureDetailDelete({ ids: ids })
            .then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.searchFn()
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },
    // 时间格式化
    dateFormat1: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
/deep/.el-form{
  width: 100%;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
